import React from "react";
import Input from '../../Input/Input';

export function RenderInput(props) {
  const {label, ...otherProps} = props;

  return <Input labelText={label} {...otherProps} />;
}
